window.onAddExtraService = (id, state, block_id, element) => {
  if (!state) {
    $(`#${block_id} .js-extra_service_input`).prop('checked', false);
  }


  if ($(element).data('service-extra-main') && !state) {
    const extrasToRemove = $(element).data('service-extra-main');
    $('[data-service-extra-for="' + extrasToRemove + '"]').prop('checked', false);
  }

  if ($(element).data('service-extra-main') && $(element).hasClass('js--should-hide')) {
    const extrasToRemove = $(element).data('service-extra-main');
    const mainModalButton = $('[data-service-slug="' + extrasToRemove + '"]');
    if (!state) {
      const mainCheckboxElParent = $(element).closest('.styled-checkbox');
      mainCheckboxElParent.removeClass('show-checkbox')
      mainModalButton.find('.js--extra-service-button-learn').removeClass('d-none')
      mainModalButton.find('.js--extra-service-button-change').addClass('d-none')
      mainModalButton.find('.js--extra-service-price').addClass('invisible')
    } else {
      mainModalButton.find('.js--extra-service-button-learn').addClass('d-none')
      mainModalButton.find('.js--extra-service-button-change').removeClass('d-none')
      mainModalButton.find('.js--extra-service-price').removeClass('invisible')
    }
  }

  if ($(element).data('service-extra-main') && $(element).hasClass('js--has-base-and-extra')) {
    const extrasToRemove = $(element).data('service-extra-main');
    const mainModalButton = $('[data-service-slug="' + extrasToRemove + '"]');
    if (!state) {
      const priceBlock = mainModalButton.find('.js--price-without-currency')
      mainModalButton.find('.js--extra-service-button-learn').removeClass('d-none')
      mainModalButton.find('.js--extra-service-button-change').addClass('d-none')
      priceBlock.text(priceBlock.data('base-price'))
    }
  }

  oc.ajax('onAddExtraService', {
    data: {
      id: id,
      state: state
    },
    update: {
      'calculators/prices': true,
      'calculators/detailing/prices': true,
    }

  }).done(function (data) {

    if ($('[data-selected-service-amount]').data('selected-service-amount') > 0) {
      $('.js--calculator-file-upload').removeClass('d-none');
    } else {
      $('.js--calculator-file-upload').addClass('d-none');
    }
  });
}

let prevElementId;

window.onAddExtraServiceOption = (service_id, id, element) => {
  if (element.type === 'radio') {
    if (element.checked === element.prevChecked && prevElementId === element.id) {
      element.checked = !element.checked;
    }
    element.prevChecked = element.checked;
    prevElementId = element.id;
  } else if ($(element).data('service-extra-for') && element.checked) {
    const mainToCheck = $(element).data('service-extra-for');
    $('[data-service-extra-main="' + mainToCheck + '"]').prop('checked', true);
  }

  if ($(element).hasClass('js--should-hide-checkbox')) {
    const mainToCheck = $(element).data('service-extra-for');
    const mainCheckboxEl = $('[data-service-extra-main="' + mainToCheck + '"]');
    const mainModalButton = $('[data-service-slug="' + mainToCheck + '"]');
    const mainCheckboxElParent = mainCheckboxEl.closest('.styled-checkbox');

    if (element.checked) {
      mainCheckboxEl.prop('checked', true)
      mainCheckboxElParent.addClass('show-checkbox')
      mainModalButton.find('.js--extra-service-button-learn').addClass('d-none')
      mainModalButton.find('.js--extra-service-button-change').removeClass('d-none')
      mainModalButton.find('.js--extra-service-price').removeClass('invisible')
      mainModalButton.find('.js--price-without-currency').text($(element).data('price'))
    } else {
      mainCheckboxEl.prop('checked', false)
      mainCheckboxElParent.removeClass('show-checkbox')
      mainModalButton.find('.js--extra-service-button-learn').removeClass('d-none')
      mainModalButton.find('.js--extra-service-button-change').addClass('d-none')
      mainModalButton.find('.js--extra-service-price').addClass('invisible')
      oc.ajax('onAddExtraService', {
        data: {
          id: service_id,
          state: 0
        },
      })
    }
  } else {
    const mainToCheck = $(element).data('service-extra-for');
    const checkedCount = $(element).closest('.services').find('input[type="checkbox"]:checked').length;
    const mainModalButton = $('[data-service-slug="' + mainToCheck + '"]');
    const currencyBlock = mainModalButton.find('.js--price-without-currency');
    if (element.checked) {
      mainModalButton.find('.js--extra-service-button-learn').addClass('d-none')
      currencyBlock.text(Number(currencyBlock.text()) + Number($(element).data('price')))

    } else {
      mainModalButton.find('.js--extra-service-button-learn').addClass('d-none')
      currencyBlock.text(Number(currencyBlock.text()) - Number($(element).data('price')))

    }
    if (checkedCount > 0) {
      mainModalButton.find('.js--extra-service-button-learn').addClass('d-none')
      mainModalButton.find('.js--extra-service-button-change').removeClass('d-none')
      // mainModalButton.find('.js--price-without-currency').text($(element).data('price'))
    } else {
      mainModalButton.find('.js--extra-service-button-learn').removeClass('d-none')
      mainModalButton.find('.js--extra-service-button-change').addClass('d-none')
    }
  }


  oc.ajax('onAddExtraServiceOption', {
    data: {
      service_id: service_id,
      id: id,
      state: element.checked
    },
    update: {
      'calculators/prices': true,
      'calculators/detailing/prices': true,
    }
  }).done(function (data) {
    if ($('[data-selected-service-amount]').data('selected-service-amount') > 0) {
      $('.js--calculator-file-upload').removeClass('d-none');
    } else {
      $('.js--calculator-file-upload').addClass('d-none');
    }
  });
}

window.onDeliveryOptionChange = (key) => {
  oc.ajax('onDeliveryOptionChange', {
    data: {
      key: key
    },
    update: {
      'calculators/prices': true
    }
  })
}
